import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class TimelineHandler {
    constructor() {
        this.timeline = null;
    }

    init() {
        const timelineContainer = document.querySelector('[data-timeline="image"]');

        if (!timelineContainer) return;

        const imageContainer = timelineContainer.querySelector('.sm\\:w-1\\/2.justify-center');
        if (!imageContainer) return;

        const images = imageContainer.querySelectorAll('.absolute.rounded-sm');
        const timelineItems = timelineContainer.querySelectorAll('.flex.pl-lg');

        if (images.length === 0 || timelineItems.length === 0) return;

        // Set initial state - hide all images except first
        images.forEach((image, index) => {
            gsap.set(image, {
                opacity: index === 0 ? 1 : 0
            });
        });

        // Create scroll trigger that pins the container
        ScrollTrigger.create({
            trigger: timelineContainer,
            start: () => `top+=${images[0].offsetHeight / 2.2} center`,
            end: () => `+=${timelineContainer.offsetHeight - window.innerHeight}`,
            pin: imageContainer,
            scrub: true,
            onUpdate: (self) => {
                // Calculate which image should be active based on scroll progress
                const progress = self.progress;
                const activeIndex = Math.floor(progress * images.length);
                const clampedIndex = Math.min(activeIndex, images.length - 1);

                // Fade between images
                images.forEach((image, index) => {
                    if (index === clampedIndex) {
                        gsap.to(image, {
                            opacity: 1,
                            duration: 0.3,
                            ease: "power2.out"
                        });
                    } else {
                        gsap.to(image, {
                            opacity: 0,
                            duration: 0.3,
                            ease: "power2.out"
                        });
                    }
                });
            }
        });

        // Add scroll trigger for each timeline item to sync with images
        timelineItems.forEach((item, index) => {
            ScrollTrigger.create({
                trigger: item,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    if (images[index]) {
                        images.forEach((img, imgIndex) => {
                            gsap.to(img, {
                                opacity: imgIndex === index ? 1 : 0,
                                duration: 0.5,
                                ease: "power2.out"
                            });
                        });
                    }
                    // Update active states for year badge and pin
                    this.updateActiveStates(index, timelineItems);
                },
                onEnterBack: () => {
                    if (images[index]) {
                        images.forEach((img, imgIndex) => {
                            gsap.to(img, {
                                opacity: imgIndex === index ? 1 : 0,
                                duration: 0.5,
                                ease: "power2.out"
                            });
                        });
                    }
                    // Update active states for year badge and pin
                    this.updateActiveStates(index, timelineItems);
                }
            });
        });
    }

    updateActiveStates(activeIndex, timelineItems) {
        timelineItems.forEach((item, index) => {
            const yearBadge = item.querySelector('[data-timeline-year]');
            const pin = item.querySelector('[data-timeline-pin]');
            const pinInner = item.querySelector('[data-timeline-pin-inner]');

            if (index === activeIndex) {
                // Active state
                if (yearBadge) {
                    yearBadge.classList.remove('bg-primary-1');
                    yearBadge.classList.add('bg-6-20');
                }
                if (pin) {
                    pin.classList.remove('bg-1-40');
                    pin.classList.add('bg-primary-2');
                }
                if (pinInner) {
                    pinInner.classList.remove('bg-primary-2');
                    pinInner.classList.add('bg-primary-6');
                }
            } else {
                // Inactive state
                if (yearBadge) {
                    yearBadge.classList.remove('bg-6-20');
                    yearBadge.classList.add('bg-primary-1');
                }
                if (pin) {
                    pin.classList.remove('bg-primary-2');
                    pin.classList.add('bg-1-40');
                }
                if (pinInner) {
                    pinInner.classList.remove('bg-primary-6');
                    pinInner.classList.add('bg-primary-2');
                }
            }
        });
    }
}